import type { ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';
import { Icon, type IconName } from './icon';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  name: IconName;
  label: string;
  bare?: boolean;
  size?: number;
}

export function IconButton({
  name,
  label,
  bare,
  size = 22,
  className,
  type = 'button',
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      className={cn('wb-iconbtn', bare && 'wb-iconbtn--bare', className)}
      {...rest}
    >
      <Icon name={name} size={size} />
    </button>
  );
}
